const PreloadImage = require('../request/preload-image');
const AnimationSequence = require('../velocity/animation-sequence');
const SimulationResultSequence = require('./animations/simulation-result-sequence');

/**
 * SimulationResult
 * @class
 */
class SimulationResult {

  elms = {
    beforeClass: 'js-simulation-result-before',
    afterClass : 'js-simulation-result-after',
  }

  /**
   * @instance
   * @param _$el {HTMLElement}
   */
  constructor(_$el) {
    this.$$before = _$el.getElementsByClassName(this.elms.beforeClass);
    this.$$after  = _$el.getElementsByClassName(this.elms.afterClass);

    const { runSequence } = new AnimationSequence();
    const sequences_ = new SimulationResultSequence(_$el);

    this.images = new PreloadImage(document.body);
    this.images.load()
    .then( () => {
      runSequence(sequences_.getSequences(), {
        complete: () => {
          _.forEach(this.$$before, (_$before) => {
            _$before.style.display = null;
          });
          _.forEach(this.$$after, (_$after) => {
            _$after.style.display = null;
          });
        },
      });
    });
  }

}

/**
 * class exports
 */
module.exports = SimulationResult;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/ui/simulation-result.js
 **/